<template>
  <div class="-main-header">
    <menu-bar />
    <ian-controls />
  </div>
</template>

<script>
/** (GW)
 * Asset Editor's pages + overlay assets Vue (left bar)
 */
import MenuBar from './MenuBar.vue';
import IanControls from '../InAssetNavigation/IanControls.vue';

export default {
  components: {
    MenuBar,
    IanControls,
  },

  methods: {},
};
</script>

<style lang="scss" scoped>
.-main-header {
  display: flex;
  align-items: stretch;
  height: 100%;
}
</style>
